import {Button} from '@wandb/components';
import React from 'react';

import {ViewInGrafanaButton} from './ViewInGrafanaButton';

interface SlurmJobSectionProps {
  jobId: string;
  isRunLive: boolean;
  readOnly?: boolean;
  grafanaUrl?: string;
  onViewDetails: () => void;
  onCancel: () => void;
  onRequeue: () => void;
}

export function SlurmJobSection({
  jobId,
  isRunLive,
  readOnly = false,
  grafanaUrl,
  onViewDetails,
  onCancel,
  onRequeue,
}: SlurmJobSectionProps) {
  return (
    <>
      <div className="mt-16 flex h-24 items-center justify-start gap-8">
        <div className="text-base font-semibold">Slurm Job</div>
      </div>
      <div className="mt-4">
        <button
          type="button"
          aria-label="View Slurm job details"
          className="cursor-pointer border-none bg-transparent p-0 font-medium text-wb-text-link underline"
          onClick={onViewDetails}>
          {jobId}
        </button>
      </div>
      <div className="mt-8 flex gap-8">
        {isRunLive && !readOnly && (
          <Button
            variant="secondary"
            size="sm"
            startIcon="do-not-prohibited"
            onPress={onCancel}>
            Cancel Slurm job
          </Button>
        )}
        {!readOnly && (
          <Button
            variant="secondary"
            size="sm"
            startIcon="reset"
            onPress={onRequeue}>
            Requeue Slurm job
          </Button>
        )}
        {grafanaUrl && <ViewInGrafanaButton grafanaUrl={grafanaUrl} />}
      </div>
    </>
  );
}
